<template>
   <jd-dialog
      title="订单详情"
      custom-class="system-dialog"
      :visible.sync="isShow"
      width="50%"
      :isShowCancel="false"
      @close="closeDialog"
      @confirm="closeDialog"
    >
    <div class="new-table-box">
      <jd-table
        :loading="loading"
        :tableInfo="tableInfo"
        :tableData="orderDetailData"
        style="width: 100%"
        :pageInfo="{
          pageNum: pageInfo.current,
          pageSize: pageInfo.size,
          total: pageInfo.total,
        }"
        @handlePage="handlePage"
      >
        <template slot="orderSlot" slot-scope="scope">
          {{ lockType==1 ? scope.row.orderPrice : scope.row.orderPayment  }}元
        </template>
      </jd-table>
    </div>
  </jd-dialog>
</template>

<script>
import { getOrderRrankorderDetail } from "@/api/jhk/paradiseAndTaskCommonController.js";
import { getLockOrderPage } from "@/api/jhk/integralCenter/PointActivityAnalyticController.js";

export default {
  props: {
    currentId: {
      // 活动数据
      type: Number,
      default: -1,
    },
    currentPin: {
      // pin
      type: String,
      default: "",
    },
    lockType: {
      // 是否为锁权
      type: Number,
      default: 0,
    },
    activityId: {
      // 活动类型
      type: [Number,String],
      default: "",
    },
  },
  data() {
    return {
      isShow: true,
      tableInfo: [
        {
          label: "订单编号",
          prop: "orderId",
          minWidth: 120,
        },
        {
          label: "下单时间",
          prop: "orderStartTime",
          minWidth: 120,
        },
        {
          label: "付款时间",
          prop: "paymentConfirmTime",
          minWidth: 120,
        },
        {
          label: "订单金额",
          slot: "orderSlot",
          minWidth: 120,
        },
        {
          label: "订单状态",
          prop: "orderStateRemark",
          minWidth: 120,
        },
      ],
      loading: false, // 加载
      orderDetailData: [], // 订单明细
      pageInfo: {
        // 订单明细分页
        current: 1, // 当前页
        size: 10, // 每页条数
        total: 0, // 总条数
      },
    };
  },
  methods: {
    closeDialog() {
      this.$emit("closeDialog")
    },
    getDetail() {
      this.loading = true;
      let fn = this.lockType ? getLockOrderPage : getOrderRrankorderDetail
      let params = {
        id: this.currentId,
        current: this.pageInfo.current,
        size: this.pageInfo.size,
      }
      let params1 = {
        pin: this.currentPin,
        current: this.pageInfo.current,
        size: this.pageInfo.size,
        activityId: this.activityId,
      }
      const commonParams =  this.lockType ? params1 : params
      fn(commonParams).then(res => {
        this.loading = false;
        if(res&&res.code == 1) {
          this.orderDetailData = res.data.records;
          this.pageInfo.total = res.data.total;
        }
      }).catch(err => {
        this.loading = false;
      })
    },
    handlePage(page) {
      this.pageInfo.current = page.pageNum;
      this.pageInfo.size = page.pageSize;
      this.getDetail();
    },
  },
  created() {
    this.getDetail();
  }
};
</script>
